export default {
  fetchUser(state) {
    return state.user;
  },
  fetchItem(state) {
    return state.item;
  },
};
